import {useEffect} from "react";

/**
 * Keeps --vv-top / --vv-height on an element in sync with the visual
 * viewport (the part of the page actually visible). On phones the keyboard
 * shrinks and scrolls the visual viewport; fixed overlays sized with these
 * variables stay exactly on screen instead of showing the page beneath.
 */
export const useVisualViewport = (ref, active) => {
    useEffect(() => {
        const vv = window.visualViewport;
        const el = ref.current;
        if (!active || !vv || !el) return undefined;
        const update = () => {
            el.style.setProperty("--vv-top", `${vv.offsetTop}px`);
            el.style.setProperty("--vv-height", `${vv.height}px`);
        };
        update();
        vv.addEventListener("resize", update);
        vv.addEventListener("scroll", update);
        return () => {
            vv.removeEventListener("resize", update);
            vv.removeEventListener("scroll", update);
            el.style.removeProperty("--vv-top");
            el.style.removeProperty("--vv-height");
        };
    }, [ref, active]);
};
